<div class="relative w-full -mt-[200px] z-[1] pb-20 md:pb-24">
  <div class="max-w-[1200px] mx-auto px-6">
    <article class="bg-white rounded-[16px] shadow-[0_4px_24px_rgba(0,0,0,0.06)] overflow-hidden">
      
      <!-- Back Button Skeleton -->
      <div class="px-6 md:px-10 pt-8 md:pt-10">
        <div class="h-5 w-32 bg-gray-200 rounded-full animate-pulse"></div>
      </div>

      <!-- Profile Header Skeleton -->
      <section class="px-6 md:px-10 py-10 md:py-12">
        <div class="flex flex-col lg:flex-row gap-8 md:gap-10 items-start lg:items-center">
          
          <!-- Photo Skeleton -->
          <div class="flex-shrink-0 w-48 md:w-56 lg:w-64">
            <div class="w-full aspect-square rounded-[16px] bg-gray-200 animate-pulse"></div>
          </div>

          <!-- Name, Role, Department Skeleton -->
          <div class="flex-1 min-w-0 space-y-4">
            <div class="space-y-3">
              <div class="h-12 md:h-14 lg:h-16 bg-gray-200 rounded-xl animate-pulse w-3/4"></div>
              <div class="h-7 md:h-8 bg-gray-200 rounded-lg animate-pulse w-1/2" style="animation-delay: 0.1s;"></div>
              <div class="h-5 md:h-6 bg-gray-200 rounded-lg animate-pulse w-2/5" style="animation-delay: 0.2s;"></div>
            </div>
          </div>
          
        </div>
      </section>

      <!-- Short Bio Skeleton -->
      <section class="px-6 md:px-10 py-8 md:py-10">
        <div class="space-y-3 max-w-4xl">
          <div class="h-6 md:h-7 bg-gray-200 rounded-lg animate-pulse w-full" style="animation-delay: 0.3s;"></div>
          <div class="h-6 md:h-7 bg-gray-200 rounded-lg animate-pulse w-11/12" style="animation-delay: 0.4s;"></div>
          <div class="h-6 md:h-7 bg-gray-200 rounded-lg animate-pulse w-4/5" style="animation-delay: 0.5s;"></div>
        </div>
      </section>

      <!-- Full Bio Skeleton -->
      <section class="px-6 md:px-10 py-8 md:py-10 border-t border-gray-100">
        <div class="h-8 md:h-9 bg-gray-200 rounded-xl animate-pulse w-48 mb-6" style="animation-delay: 0.6s;"></div>
        <div class="space-y-2.5 max-w-4xl">
          <div class="h-5 bg-gray-200 rounded-lg animate-pulse w-full" style="animation-delay: 0.7s;"></div>
          <div class="h-5 bg-gray-200 rounded-lg animate-pulse w-full" style="animation-delay: 0.75s;"></div>
          <div class="h-5 bg-gray-200 rounded-lg animate-pulse w-11/12" style="animation-delay: 0.8s;"></div>
          <div class="h-5 bg-gray-200 rounded-lg animate-pulse w-10/12" style="animation-delay: 0.85s;"></div>
          <div class="h-5 bg-gray-200 rounded-lg animate-pulse w-full" style="animation-delay: 0.9s;"></div>
          <div class="h-5 bg-gray-200 rounded-lg animate-pulse w-9/12" style="animation-delay: 0.95s;"></div>
        </div>
      </section>

      <!-- Expertise Skeleton -->
      <section class="px-6 md:px-10 py-8 md:py-10 border-t border-gray-100">
        <div class="h-8 md:h-9 bg-gray-200 rounded-xl animate-pulse w-32 mb-8" style="animation-delay: 1s;"></div>
        <div class="flex flex-wrap gap-2.5">
          <div class="h-9 w-24 bg-gray-200 rounded-full animate-pulse" style="animation-delay: 1.05s;"></div>
          <div class="h-9 w-32 bg-gray-200 rounded-full animate-pulse" style="animation-delay: 1.1s;"></div>
          <div class="h-9 w-28 bg-gray-200 rounded-full animate-pulse" style="animation-delay: 1.15s;"></div>
          <div class="h-9 w-36 bg-gray-200 rounded-full animate-pulse" style="animation-delay: 1.2s;"></div>
          <div class="h-9 w-24 bg-gray-200 rounded-full animate-pulse" style="animation-delay: 1.25s;"></div>
          <div class="h-9 w-30 bg-gray-200 rounded-full animate-pulse" style="animation-delay: 1.3s;"></div>
        </div>
      </section>

      <!-- Contact Skeleton -->
      <section class="px-6 md:px-10 py-8 md:py-10 pb-10 md:pb-12 border-t border-gray-100">
        <div class="h-8 md:h-9 bg-gray-200 rounded-xl animate-pulse w-32 mb-8" style="animation-delay: 1.35s;"></div>
        <div class="flex flex-wrap gap-3">
          <div class="h-12 w-12 bg-gray-200 rounded-full animate-pulse" style="animation-delay: 1.4s;"></div>
          <div class="h-12 w-12 bg-gray-200 rounded-full animate-pulse" style="animation-delay: 1.45s;"></div>
          <div class="h-12 w-12 bg-gray-200 rounded-full animate-pulse" style="animation-delay: 1.5s;"></div>
          <div class="h-12 w-12 bg-gray-200 rounded-full animate-pulse" style="animation-delay: 1.55s;"></div>
        </div>
      </section>

    </article>
  </div>
</div>
